import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WkcNotice from '@/types/table/wkcNotice';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WkcNoticeData extends WkcNotice {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WkcNoticeController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcNoticeData>>(API_CONTEXT + '/app/wkcNotice/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WkcNoticeData>(API_CONTEXT + '/app/wkcNotice/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wkcNotice/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wkcNotice/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/wkcNotice/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcNotice/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcNotice/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcNotice/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcNotice/deleteBatch', params, httpOptions);
  }
  static startOnlyNotice(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcNotice/startOnly/notice', params, httpOptions);
  }
  static startWithBusinessKeyNotice(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcNotice/startWithBusinessKey/notice', params, httpOptions);
  }
  static startAndTakeUserTaskNotice(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcNotice/startAndTakeUserTask/notice', params, httpOptions);
  }
  static startAndSaveDraftNotice(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcNotice/startAndSaveDraft/notice', params, httpOptions);
  }
  static submitUserTaskNotice(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcNotice/submitUserTask/notice', params, httpOptions);
  }
  static viewTaskBusinessDataNotice(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcNotice/viewTaskBusinessData/notice', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataNotice(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcNotice/viewHistoricTaskBusinessData/notice', params, httpOptions);
  }
  static listWorkOrderNotice(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcNotice/listWorkOrder/notice', params, httpOptions);
  }
  static viewCopyBusinessData(params: ANY_OBJECT) {
    return super.post(API_CONTEXT + '/app/wkcNotice/viewCopyBusinessData', params);
  }

  static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
      return super.post<TableData<WkcNoticeData>>(API_CONTEXT + '/app/dept/getUserInformation', params, httpOptions);
    }
   static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }
}
